export default class extends ApplicationController {
  static values = {toggled: Boolean}

  toggleAttributes(event) {
    event.preventDefault();

    this.toggledValue = !this.toggledValue
  }
}
